import {
  ChangeEvent,
  FC,
  FocusEvent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import {
  createStyles,
  makeStyles,
  TextField,
  TextFieldProps,
} from "@material-ui/core";

import { NumberInput } from "components";
import theme from "theme";
import { textFieldPurpleStyles } from "theme/constants";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: "120px",
      ...textFieldPurpleStyles,
    },
  }),
);

const RangeTextInput: FC<
  TextFieldProps & {
    rangeKey: string;
    label: string;
    value: string;
    onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    startAdornment?: ReactNode;
    inputComponent?: FC;
  }
> = ({
  rangeKey,
  label,
  value,
  onChange,
  startAdornment,
  inputComponent,
  ...props
}) => {
  const classes = useStyles();
  const [shrink, setShrink] = useState(false);

  const handleFocus = (
    event: FocusEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    setShrink(true);
    props.onFocus && props.onFocus(event);
  };

  const handleBlur = (
    event: FocusEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    if (event.target.value.length === 0) {
      setShrink(false);
    }
    props.onBlur && props.onBlur(event);
  };

  useEffect(() => {
    if (!value.length) {
      setShrink(false);
    } else {
      setShrink(true);
    }
  }, [value.length]);

  return (
    <TextField
      id={`range-${rangeKey}-${label}`}
      label={label}
      className={classes.root}
      value={value}
      onChange={onChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      margin="dense"
      variant="outlined"
      InputProps={{
        inputComponent: inputComponent || NumberInput,
        startAdornment: shrink && startAdornment,
      }}
      InputLabelProps={{ shrink: shrink }}
      style={{ marginRight: theme.spacing(1) }}
    />
  );
};

export default RangeTextInput;
